import {
  SET_NAV
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_NAV:
      return action.payload;

    default:
      return state;
  }
}
